import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastsManager } from 'ng2-toastr';
import { Observable } from 'rxjs/Observable';
import { IPagedResults } from '../../core/interfaces';
import { ReportTypeModel, Type1Model } from '../../models';
import { CustomTypeService, SettingsService, Type3Service, Type4Service } from '../../services';
import { IncidentTypeService } from '../../services/incident-type.service';

@Component({
    selector: 'app-incident-types-edit',
    templateUrl: './incident-types-edit.component.html',
    styleUrls: ['./incident-types-edit.component.scss', '../layout/layout.component.scss']
})
export class IncidentTypesEditComponent implements OnInit {
    modalIdData: number;
    photoSrc: string;
    isAdminOrUserEditor: boolean;
    sitesList: any[];
    currentUser: any;
    showSpinner: boolean;

    RequiredReportTypes: any[];
    SelectedRequiredReports: any[] = [];

    reportFields: any[];
    selectedReportFields: any[] = [];
    reportField: any;
    reportIncludedItems: any[] = [];
    reportExcludedItems: any[] = [];

    ShownReportTypes: any[];
    SelectedShownReports: any[] = [];
    type1: string = "Type 1";
    model: Type1Model = <Type1Model>
        {

        };

    type2Items: any[] = [];
    type3Items: any[] = [];
    type4Items: any[] = [];

    constructor(private incidentTypeService: IncidentTypeService,
        private route: ActivatedRoute,
        private toastr: ToastsManager,
        private settingService: SettingsService,
        private customTypeService: CustomTypeService,
        private type3Service: Type3Service,
        private type4Service: Type4Service,
        public activeModal: NgbActiveModal,
        private router: Router) { }

    ngOnInit() {
        this.setDefaults();

        this.route.params.subscribe((params) => {
            if (params) {
                const id = params['id'];

                if (id == undefined) {
                    this.loadData(this.modalIdData);
                } else {
                    this.loadData(id);
                }

            }
        });

        this.loadSetting();
    }

    loadSetting() {
        var currentUser = JSON.parse(localStorage.getItem('currentUser'));

        this.settingService.getValue("type1", currentUser.accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {
                if (response.Data != null) {
                    this.type1 = response.Data.Value;
                }
            });

        var SiteId = +localStorage.getItem('IncidentcurrentSiteId');
        this.customTypeService.getAllCustomTypes(this.currentUser.accountId, SiteId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: any) => {
                this.type2Items = response.Data;
            });

        this.type3Service.getAllType3(this.currentUser.accountId, SiteId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: any) => {
                this.type3Items = response.Data;
            });

        this.type4Service.getAllType4(this.currentUser.accountId, SiteId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: any) => {
                this.type4Items = response.Data;
            });
    }

    public setDefaults() {
        let now = new Date();
        this.photoSrc = "/assets/images/upload-empty.png";
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (this.currentUser.role === 'admin') {
            this.isAdminOrUserEditor = true;
        }
        else if (this.currentUser.role === 'user') {
            this.isAdminOrUserEditor = false;
        }
    }

    public loadData(id: number) {
        this.showSpinner = true;

        this.incidentTypeService.getIncidentType(id)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: IPagedResults<any>) => {
                this.model = response.Data;
                this.settingService.getDailyReportFields()
                    .catch((err: any) => {
                        return Observable.throw(err);
                    })
                    .finally(() => {
                        setTimeout(() => {
                            this.showSpinner = false;
                        }, 1000);
                    })
                    .subscribe(response => {
                        let unselected = response.Data.filter(rf => this.model.Fields.find(e => e.Id === rf.Id) == null);
                        let selected = response.Data.filter(rf => {
                            let f: any = this.model.Fields.find(e => e.Id === rf.Id);

                            if (f != null) {
                                rf.Label = f.Label;
                                rf.Value = f.Value;
                                rf.DataSource = f.DataSource;
                                rf.IsRequired = f.IsRequired;
                                rf.SortOrder = f.SortOrder;
                                rf.CustomEditorName = f.CustomEditorName;
                                rf.ExcludedValues = f.ExcludedValues;
                            }

                            return f != null;
                        });

                        this.reportFields = unselected.map(rf => {
                            return {
                                enabled: true,
                                id: rf.Id,
                                defaultLabel: rf.Label,
                                label: rf.Label,
                                dataSource: rf.DataSource,
                                value: rf.Value,
                                type: rf.Type,
                                fieldType: rf.FieldType,
                                fieldTypeFlag: rf.FieldTypeFlag,
                                editorType: rf.CustomEditorName,
                                required: rf.IsRequired,
                                order: rf.SortOrder
                            }
                        });

                        this.selectedReportFields = selected.map(rf => {
                            return {
                                enabled: true,
                                id: rf.Id,
                                defaultLabel: rf.Label,
                                label: rf.Label,
                                dataSource: rf.DataSource,
                                excludedValues: JSON.parse(rf.ExcludedValues),
                                value: rf.Value,
                                type: rf.Type,
                                fieldType: rf.FieldType,
                                fieldTypeFlag: rf.FieldTypeFlag,
                                editorType: rf.CustomEditorName,
                                required: rf.IsRequired,
                                order: rf.SortOrder
                            }
                        });
                    });

                this.incidentTypeService.getAllReportTypes()
                    .catch((err: any) => {
                        return Observable.throw(err);
                    })
                    .finally(() => {
                        setTimeout(() => {
                            this.showSpinner = false;
                        }, 1000);
                    })
                    .subscribe((response: IPagedResults<any>) => {
                        this.RequiredReportTypes = response.Data;
                        // this.RequiredReportTypes = this.RequiredReportTypes.filter(x=>x.Id != 1);
                        this.model.RequiredReport.forEach(element => {
                            var reportType = new ReportTypeModel();
                            reportType = element;
                            this.SelectedRequiredReports.push(reportType);

                            this.RequiredReportTypes = this.RequiredReportTypes.filter(gElement => gElement.Id != reportType.Id)
                        });
                        // this.toastr.success(response.Message, "Success"); 
                    });

                this.incidentTypeService.getAllReportTypes()
                    .catch((err: any) => {
                        return Observable.throw(err);
                    })
                    .finally(() => {
                        setTimeout(() => {
                            this.showSpinner = false;
                        }, 1000);
                    })
                    .subscribe((response: IPagedResults<any>) => {
                        this.ShownReportTypes = response.Data;

                        this.model.ShownReport.forEach(element => {
                            var reportType = new ReportTypeModel();
                            reportType = element;
                            this.SelectedShownReports.push(reportType);

                            this.ShownReportTypes = this.ShownReportTypes.filter(gElement => gElement.Id != reportType.Id)
                        });
                        // this.toastr.success(response.Message, "Success"); 
                    });
            });
    }

    reportFieldSelected(evt) {
        if (evt.items.length > 0) {
            let item = evt.items[0];
            let excludedValues: any[] = [];

            if (item.excludedValues != null) {
                excludedValues = item.excludedValues;
            }

            this.reportField = item;

            switch (item.editorType) {
                case "VAR": {
                    this.reportIncludedItems = this.type2Items.filter(f => excludedValues.find(e => e.id === f.Id) == null).map(e => {
                        return {
                            id: e.Id,
                            name: e.Name
                        };
                    });

                    this.reportExcludedItems = excludedValues;
                } break;
                case "VEM": {
                    this.reportIncludedItems = this.type3Items.filter(f => excludedValues.find(e => e.id === f.Id) == null).map(e => {
                        return {
                            id: e.Id,
                            name: e.Name
                        };
                    });

                    this.reportExcludedItems = excludedValues;
                } break;
                case "TYPE4": {
                    this.reportIncludedItems = this.type4Items.filter(f => excludedValues.find(e => e.id === f.Id) == null).map(e => {
                        return {
                            id: e.Id,
                            name: e.Name
                        };
                    });

                    this.reportExcludedItems = excludedValues;
                }
            }
        } else {
            this.reportField = null;
        }
    }

    reportFieldMovedToSource(evt) {
        this.reportField = null;
    }

    reportFieldSettingChanged(evt) {
        this.reportField.label = evt.label;
        this.reportField.dataSource = JSON.stringify(evt.dataSource);
        this.reportField.value = evt.value;
        this.reportField.required = evt.required;
        this.reportField.excludedValues = evt.excludedValues;
    }

    requiredReportMoveToTarget() {
        this.SelectedShownReports = Array.from(this.SelectedRequiredReports);
        this.ShownReportTypes = Array.from(this.RequiredReportTypes);
    }

    requiredReportMoveToSource() {

    }

    shownReportMoveToTarget() {

    }

    shownReportMoveToSource() {

        this.ShownReportTypes.forEach(e => {
            if (this.SelectedRequiredReports.some(r => r.Id == e.Id)) {
                this.ShownReportTypes.splice(this.ShownReportTypes.indexOf(e), 1);
                this.SelectedShownReports.push(e);
            }
        });
    }

    closeModal() {
        this.activeModal.close('Close click');
    }

    public saveChanges(): void {
        //alert('test');
        this.showSpinner = true;
        this.model.RequiredReport = this.SelectedRequiredReports;
        this.model.ShownReport = this.SelectedShownReports;
        var SiteId = +localStorage.getItem('IncidentcurrentSiteId');

        this.model.SiteId = SiteId;

        this.model.Fields = this.selectedReportFields.map(rf => {
            return {
                Id: rf.id,
                Name: rf.name,
                Label: rf.label,
                DataSource: rf.dataSource,
                Value: rf.value,
                IsRequired: rf.required,
                SortOrder: rf.order,
                ExcludedValues: JSON.stringify(rf.excludedValues),
                CustomEditorName: null,
                FieldName: "",
                FieldTypeFlag: ""
            };
        });

        this.incidentTypeService.saveIncidentType(this.model)
            .catch((err: any) => {
                this.toastr.error(err, 'Error');
                return Observable.throw(err);
            }).finally(() => {
                setTimeout(() => {
                    this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response) => {
                if (response.ErrorCode) {
                    this.toastr.error(response.Message, "Error");
                }
                else {
                    //  this.toastr.success(response.Message, "Success"); 
                }
                this.SelectedRequiredReports = [];
                this.SelectedShownReports = [];
                this.ngOnInit();
                this.activeModal.close('Close click');
                //this.router.navigate([`/type1`]); 
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/incident-types/incident-types-edit.component.ts